import React from 'react';

const withStaticData = staticData => WrappedComponent => {
  const Wrapper = props => (
    <WrappedComponent {...props} {...staticData} type={'static'} />
  );

  Wrapper.displayName = `withStaticData(${WrappedComponent.displayName ||
    WrappedComponent.name ||
    'Component'})`;

  return Wrapper;
};

export default withStaticData;
